/**
 * Checks if a given route path is active based on the current pathname.
 * Uses exact matching to avoid false positives (e.g., /analytics vs /billing/analytics)
 *
 * @param routePath - The route path to check against (can be relative like 'analytics' or absolute like '/analytics')
 * @returns true if the route is active, false otherwise
 */
export const isRouteActive = (routePath?: string) => {
  const currentPathname = location.pathname;

  if (!routePath) {
    return false;
  }

  // Ensure routePath starts with '/'
  const normalizedRoute = routePath.startsWith('/')
    ? routePath
    : `/${routePath}`;

  // Handle root path specially
  if (normalizedRoute === '/') {
    return currentPathname === '/';
  }

  // Normalize paths by removing trailing slashes
  const normalizedCurrent = currentPathname.replace(/\/$/, '');
  const finalRoute = normalizedRoute.replace(/\/$/, '');

  // Check for exact match or if current path starts with route path followed by a slash
  return (
    normalizedCurrent === finalRoute ||
    normalizedCurrent.startsWith(finalRoute + '/')
  );
};
